<template>
    <transition name="slide" mode="out-in">
        <div 
            :class="className"
            style="--slide-offset: -9em"
            v-bind="$attrs"
            v-show="visible"
        >
            <OpeningsCta
                :className="btnClassName"
                v-bind="{ tabindex }"
                v-if="isDiscover"
            />
            <router-link v-if="isTax" :to="!currentPath.includes('/tax-microsite') ? '/tax-microsite' : '/discover-your-purple'" activeClass="" :class="['button', btnClassName]">
                Back to Home Page
            </router-link>
            <router-link v-if="isExperienced" to="/tax-microsite" :class="['button', btnClassName]">
                Tax Careers
            </router-link>
            <router-link v-if="isCampus" to="/campus-resources" :class="['button', btnClassName]">
                Campus Resources
            </router-link>
            <router-link v-if="isStudent" to="/kevin-ladner-scholarship" :class="['button', btnClassName]">
                Scholarships
            </router-link>
        </div>
    </transition>
</template>

<script>
import OpeningsCta from '@/components/Discover/OpeningsCta'

export default {
    
    props: {
        tabindex: [Boolean, Number],
        className: {
            type: String,
            default: 'wrapper--corner-buttons has-overflow'
        },
        btnClassName: {
            type: String,
            default: 'button--white'
        },
    },

    computed: {
        visible() {
            return this.isDiscover || this.isTax || this.isCampus
        },
        currentPath() {
            return this.$route.path
        },
        isDiscover() {
            return this.currentPath.startsWith('/discover-')
        },
        isTax() {
            return this.currentPath.includes('/tax-microsite')
        },
        isStudent() {
            if (this.isCampus) {
                return true
            }
            if (!this.isDiscover) {
                return false
            }
            const { type: userType } = this.$store.state.user
            return userType === 'student'
        },
        isExperienced() {
            if (this.currentPath.includes('-microsite')) {
                return false
            }
            const { type: userType } = this.$store.state.user
            return userType === 'experienced'
        },
        isCampus() {
            return this.currentPath.includes('campus-microsite')
        },
    },

    components: {
        OpeningsCta,
    },
}
</script>